import { render, staticRenderFns } from "./task-config.vue?vue&type=template&id=25cf0055&"
import script from "./task-config.vue?vue&type=script&lang=js&"
export * from "./task-config.vue?vue&type=script&lang=js&"
import style0 from "./task-config.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports